import React, { useMemo } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';

export const formatUniteArrayTable = (valeurs, format) => {
  let calculValeurs = [...valeurs];
  let res = [];
  for (let i = 0; i < calculValeurs.length; i++) {
    const totalSeconde = calculValeurs[i];
    let calculValeur = calculValeurs[i];
    const jours = parseInt(calculValeur / (24 * 60 * 60));
    calculValeur -= jours * (24 * 60 * 60);
    const heures = parseInt(calculValeur / (60 * 60));
    calculValeur -= heures * (60 * 60);
    const minutes = parseInt(calculValeur / 60);
    calculValeur -= minutes * 60;
    const seconde = parseInt(calculValeur);

    if (Number.isInteger(calculValeur)) {
      switch (format) {
        case 'jj:hh:mm:ss':
          res.push([jours, heures, minutes, seconde].join(':'));
          break;
        case 'hh:mm:ss':
          res.push([jours * 24 + heures, minutes, seconde].join(':'));
          break;
        case 'mm:ss':
          res.push([(jours * 24 + heures) * 60 + minutes, seconde].join(':'));
          break;
        case 'jj':
          res.push(jours);
          break;
        case 'hh':
          res.push(jours * 24 + heures);
          break;
        case 'mm':
          res.push((jours * 24 + heures) * 60 + minutes);
          break;
        case 'ss':
        default:
          res.push(totalSeconde);
          break;
      }
    } else {
      res.push(totalSeconde);
    }
  }
  return res;
};

const TableauDernieresValeursEtTotaux = ({
  configuration,
  donnees,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  dimensionWidth,
  dimensionHeight,
  donneesGraphe,
}) => {
  const generateTableData = useMemo(() => {
    if (!configuration || !donnees) {
      return { data: [], layout: {} };
    }

    let layout = {
      font: { size: 14 },
      title: {
        text: configuration.title + '<br>' + configuration.subtitle,
        font: { color: '#3c3935' },
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        x: 0,
        y: -0.0,
      },
      ...(viewobj_json_content?.layout || {}),
    };

    let headers_values = [];
    let headers_unit = [];
    let sensors_names = [];
    let noms_responsables = [];
    let dates_values = [];
    let values = [];

    for (let curve of donnees) {
      let index_sensor_name = sensors_names.indexOf(curve.sensor_name);
      let index_prefix =
        curve.prefix === '' ? -1 : headers_values.indexOf(curve.prefix);
      let index_position_in_sensor =
        curve.position_in_sensor === ''
          ? -1
          : headers_values.indexOf(curve.position_in_sensor);

      const last_index = curve.y.length - 1;
      const new_date = curve.x[last_index];

      if (index_sensor_name < 0) {
        sensors_names.push(curve.sensor_name);
        noms_responsables.push(curve.name);
        dates_values.push(new_date);
        values = values.map((col) => [...col, null]);
      } else if (dates_values[index_sensor_name] < new_date) {
        dates_values[index_sensor_name] = new_date;
      }

      index_sensor_name =
        index_sensor_name < 0 ? sensors_names.length - 1 : index_sensor_name;

      if (index_prefix < 0) {
        values.push(new Array(sensors_names.length).fill(null));
        values[values.length - 1][index_sensor_name] = curve.y[last_index];

        headers_values.push(curve.prefix || curve.position_in_sensor);
        headers_unit.push(curve.engineering_unit);
      } else {
        const targetIndex =
          index_prefix > -1 ? index_prefix : index_position_in_sensor;
        values[targetIndex][index_sensor_name] = curve.y[last_index];
      }
    }

    dates_values = convertiUtsToDate(dates_values);

    const headerColor = '#EFB805';
    const data = [
      {
        type: 'table',
        columnwidth: [6, 8, 5, 5],
        header: {
          values: [
            [checkMot('nom')],
            [checkMot('date')],
            ...headers_values.map(
              (valeur, index) => `${valeur} [${headers_unit[index]}]`
            ),
          ],
          align: ['left', 'center'],
          line: { width: 1, color: '#000000' },
          fill: { color: headerColor },
          font: { family: 'Arial', size: 17, color: 'white' },
        },
        cells: {
          values: [sensors_names, dates_values, ...values],
          align: ['left', 'center'],
          line: { color: '#000000' },
          font: { family: 'Arial', size: 17, color: ['#506784'] },
          height: 25,
        },
      },
    ];

    return { data, layout };
  }, [configuration, donnees, viewobj_json_content]);

  return (
    <BibliothequePlotly
      data={generateTableData.data}
      layout={{
        ...generateTableData.layout,
        responsive: true,
        ...viewobj_json_content,
      }}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
    />
  );
};

export default TableauDernieresValeursEtTotaux;
